module.exports = __webpack_public_path__ + "img/intucryl.802e023d.png";